/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Terms_Of_ServiceInputs */

const en_footer_terms_of_service = /** @type {(inputs: Footer_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const lv_footer_terms_of_service = /** @type {(inputs: Footer_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lietošanas noteikumi`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Footer_Terms_Of_ServiceInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const footer_terms_of_service = /** @type {((inputs?: Footer_Terms_Of_ServiceInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Terms_Of_ServiceInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_footer_terms_of_service(inputs)
	return en_footer_terms_of_service(inputs)
});